<template>
  <div>
    소셜 로그인 확인용 테스트 페이지 입니다
    <div>provider : {{ provider }}</div>
  </div>
</template>
<script>
// import { KAKAO_TOKEN } from '@/store/types'
export default {
  name: 'oauth',
  data() {
    return {
      provider: this.$route.params.provider,
      token: this.$route.query.token,
      type: this.$route.query.type,
      id: this.$route.query.id,
      previousUrl: ''
    }
  },
  async mounted() {
    this.create()
    this.previousPath()
    // this.$router.push({ name: 'store' })
  },
  methods: {
    create() {
      let tk = this.token
      localStorage.setItem('token', tk)
    },
    previousPath() {
      // if (this.type === 'a') {
      //   //console.log('a')
      //   this.$router.push('/')
      // } else if (this.type === 'b') {
      //   //console.log('b')
      //   alert('기존 회원으로 로그인 되었습니다.')
      //   this.$router.push('/')
      // } else if (this.type === 'c') {
      //   //console.log('c')
      //   this.$router.push({ name: 'join_step4', query: { type: this.type } })
      // }
      switch (this.type) {
        case 'EXISTING_USER':
          this.$router.push('/')
          break
        case 'LINKABLE_USER':
          alert('sns 로그인 연동이 완료되었습니다.')
          this.$router.push('/')
          break
        case 'NEW_USER':
          this.$router.push({
            name: 'join_step1',
            query: { type: this.type, id: this.id }
          })
          break
      }
    }
  }
}
</script>
